import PropTypes from 'prop-types'
import LinkButton from '../ui/LinkButton'
import './AsistenteFlechas.css'

const AsistenteFlechas = ({
  clickPasoAnterior,
  clickPasoSiguiente,
  limiteInferior,
  esPasoCero
}) => {
  return (
    <div className="asistenteFlechas">
      {!esPasoCero && (
        <LinkButton onClick={clickPasoAnterior} className="btn flechaArriba">
          <i className="fa fa-arrow-up flechaIcon" aria-hidden="true" />
        </LinkButton>
      )}
      {!limiteInferior && (
        <LinkButton onClick={clickPasoSiguiente} className="btn flechaAbajo">
          <i className="fa fa-arrow-down flechaIcon" aria-hidden="true" />
        </LinkButton>
      )}
    </div>
  )
}

AsistenteFlechas.propTypes = {
  clickPasoAnterior: PropTypes.func.isRequired,
  clickPasoSiguiente: PropTypes.func.isRequired,
  limiteInferior: PropTypes.bool,
  esPasoCero: PropTypes.bool
}

export default AsistenteFlechas
